<template>
<div>
  <form class="form-horizontal" @submit.prevent="submit">
    <fieldset>
      <legend>Dane ogólne</legend>
      <form-group label="Nagłówek" :error="errors['header']">
        <text-input v-model="notice.header"></text-input>
      </form-group>

      <form-group label="Treść" :error="errors['content']">
        <textarea-input v-model="notice.content" rows="5"></textarea-input>
      </form-group>

      <form-group label="Data" :error="errors['date']">
        <date-picker v-model="notice.date"></date-picker>
      </form-group>
    </fieldset>

    <fieldset>
      <legend>Zdjęcia</legend>
      <form-group label="Zdjęcia" :error="errors['photos']">
        <media-input v-model="notice.photos" multiple></media-input>
      </form-group>
    </fieldset>

    <fieldset>
      <legend>Pliki</legend>
      <form-group label="Pliki" :error="errors['files']">
        <media-input v-model="notice.files" multiple></media-input>
      </form-group>
    </fieldset>

    <submit-button :submitting="submitting"></submit-button>
  </form>
</div>
</template>
<script>
import FormGroup from './FormGroup.vue'
import TextInput from './TextInput.vue'
import FileInput from './FileInput.vue'
import MediaInput from './MediaInput.vue'
import TextareaInput from './TextareaInput.vue'
import SubmitButton from './SubmitButton.vue'
import SelectInput from './SelectInput.vue'
import TableInput from './TableInput.vue'
import DatePicker from './DatePicker.vue'
import Api from './../api'
import flash from './../Flash'
import vSelect from 'vue-select'
import moment from 'moment'

export default {
  props: {
    id: {type: [String, Number]}
  },
  components: {
    FormGroup,
    TextInput,
    FileInput,
    MediaInput,
    TextareaInput,
    SubmitButton,
    SelectInput,
    TableInput,
    DatePicker,
    vSelect,
    Api
  },
  data () {
    return {
      submitting: false,
      notice: {
        header: '',
        slug: '',
        content: '',
        date: '',
        photos: [],
        files: []
      },
      errors: []
    }
  },
  methods: {
    submit () {
      this.errors = []
      this.submitting = true
      if (this.id) {
        let notice = {...this.notice}
        Api.notice.update(this.id, notice).then(this.updateSuccess, this.updateError).then(() => { this.submitting = false })
      } else {
        let notice = {...this.notice}
        if (notice.photos) {
          notice.photos = this.notice.photos.map(p => `/api/files/${p.id}`)
        }
        if (notice.files) {
          notice.files = this.notice.files.map(p => `/api/files/${p.id}`)
        }
        Api.notice.post(notice).then(this.updateSuccess, this.updateError).then(() => { this.submitting = false })
      }
    },
    updateSuccess ({body}) {
      this.setData(body)
      flash.success('Zapisano zmiany poprawnie')
      this.$router.push({
        name: 'NoticeEdit',
        params: {
          id: this.notice.id
        }
      })
    },
    updateError ({body}) {
      const violations = body.violations
      violations.forEach(violation => {
        this.errors[violation.propertyPath] = violation.message
      })
    },
    fetchData () {
      if (this.id) {
        Api.notice.get(this.id).then(this.fetchSuccess)
      }
    },
    fetchSuccess ({body}) {
      this.setData(body)
    },
    setData (body) {
      body.date = moment(body.date).format('YYYY-MM-DD')
      this.notice = body
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// NoticeAddEdit.vue?0c523c74